import { ClassificaDTO } from "./classificaDTO";
import { UtenteDTO } from "./utenteDTO";
import { VisibilitaFascicoloDTO } from "./visibilita-fascicoloDTO";
import { RiferimentiPosizioneDTO } from "./riferimento-posizioneDTO";
import { TipoIstanzaFascicoloDTO } from "./tipo-istanza-fascicoloDTO";
import { StrutturaDTO } from "./strutturaDTO";
import { SettoreDTO } from "./settoreDTO";
import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";

export class WrapperCollegamentoFascicoloDTO {
  id: string;

  tipologia: TipoIstanzaFascicoloDTO;

  oggetto: string;

  segnaturaArchivistica: string;

  stato: string;

  classifica: ClassificaDTO;

  dataApertura: string;

  inseritoDa: UtenteDTO;

  visibilitaElemento: VisibilitaFascicoloDTO[];

  strutturaResponsabile: SettoreDTO;

  riferimentoPosizione: RiferimentiPosizioneDTO;

  segnatura: string;

  visibilitaFascicolo: VisibilitaFascicoloDTO[];
}
